import { Formik } from 'formik';
import { useMemo } from 'react';
import Form from './Form';
import { apiKeyService } from 'services';
import { useModal } from 'hooks/Modal';
import StyledModal, {
  ModalType,
} from 'components/Modal/styledModal/StyledModal';
import { useMemoTranslations } from 'hooks/Intl';
import * as translations from 'intls/apiKey';
import * as modalTranslations from 'intls/modals';

interface EditModalProps {
  apiKey: ApiKey;
  fetchApiKeys: () => Promise<void>;
}

const EditModal = ({ apiKey, fetchApiKeys }: EditModalProps) => {
  const { actions } = useModal();

  const intl = useMemoTranslations(translations);
  const intlModals = useMemoTranslations(modalTranslations);

  const initialValues = useMemo(
    () => ({
      capabilities: apiKey.capabilities,
      domains: apiKey.domains,
    }),
    []
  );

  const submit = async (values: typeof initialValues) => {
    try {
      actions.showLoading();

      const { capabilities, domains } = values;
      const handledDomains = domains.filter(domain => domain);
      await apiKeyService.update(apiKey.api_key_id, {
        capabilities,
        domains: handledDomains,
      });

      actions.hideLoading();
      actions.showModal(
        '',
        <StyledModal
          type={ModalType.SUCCESS}
          title={intl.EDIT_PEMISSIONS_SUCCESS}
        />,
        false
      );
    } catch (error) {
      actions.hideLoading();
      actions.showModal(
        '',
        <StyledModal
          type={ModalType.ERROR}
          title={intlModals.UNEXPECTED_ERROR}
        />,
        false
      );
    } finally {
      fetchApiKeys();
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={submit}>
      {formikProps => <Form formikProps={formikProps} />}
    </Formik>
  );
};

export default EditModal;
